/**
 * Resolve a BE-stored static asset URL (e.g. `course.thumbnailUrl` =
 * `/lms/thumbnails/phishing-101.svg`) to an absolute URL the browser can
 * fetch. BE stores relative paths because the value shouldn't bake in
 * the hostname (which differs across environments). The FE renders
 * these directly in `<img src>`, so we must prefix with the BE origin.
 *
 * - Absolute URLs (https:// or data:) pass through untouched.
 * - Empty / null input returns empty string.
 * - Relative paths are prefixed with NEXT_PUBLIC_API_URL (trailing slash
 *   stripped) so `/lms/thumbnails/foo.svg` →
 *   `https://hfv3-backend.humanfirewall.me/lms/thumbnails/foo.svg`.
 */
export function resolveAssetUrl(url: string | null | undefined): string {
  if (!url) return '';
  // Already absolute (http, https, data:, blob:)
  if (/^(https?:|data:|blob:)/i.test(url)) return url;

  const apiBase =
    typeof process !== 'undefined' && process.env.NEXT_PUBLIC_API_URL
      ? process.env.NEXT_PUBLIC_API_URL.replace(/\/$/, '')
      : '';
  if (!apiBase) return url; // SSR/build with no env — fall through unchanged

  return `${apiBase}${url.startsWith('/') ? '' : '/'}${url}`;
}
